import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ZoomProvider } from "@/components/chat/ZoomContext";
import { RequireAuth } from "@/components/RequireAuth";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import PnLCalculator from "@/pages/PnLCalculator";
import FunnelAudit from "@/pages/FunnelAudit";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ZoomProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/"
                element={
                  <RequireAuth>
                    <Dashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="/chat/:gptId"
                element={
                  <RequireAuth>
                    <Chat />
                  </RequireAuth>
                }
              />
              <Route
                path="/admin"
                element={
                  <RequireAuth adminOnly>
                    <Admin />
                  </RequireAuth>
                }
              />
              <Route
                path="/account"
                element={
                  <RequireAuth>
                    <Account />
                  </RequireAuth>
                }
              />
              <Route
                path="/tools/pnl-calculator"
                element={
                  <RequireAuth>
                    <PnLCalculator />
                  </RequireAuth>
                }
              />
              <Route
                path="/tools/funnel-audit"
                element={
                  <RequireAuth>
                    <FunnelAudit />
                  </RequireAuth>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ZoomProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
